export const imageFragment = `
	fragment Image on Image {
		id
		altText
		url
		width
		height
	}
`;
